export const LOAD_PERMISSIONS = "LOAD_PERMISSIONS";
export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const PERMISSION_LOADING = "PERMISSION_LOADING";